import type React from 'react';

import cn from '../../../../utils/cn';

export interface DropdownOverlayProps {
  children: React.ReactNode;
  className?: string;
}

const DropdownOverlay = ({ children, className }: DropdownOverlayProps) => {
  return <div className={cn('flex w-80 flex-col gap-2.5 rounded-md border border-gray-light bg-white py-2.5', className)}>{children}</div>;
};

export default DropdownOverlay;
